import axios from 'axios'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'
import config from '../../../config'

export async function getCCTV(condition = {}) {
  let response = {}
  try {
    response = await axios.get(`${config.eastCoastDataApi()}BaseData/VideoCamera`)

  } catch (err) {
    console.error('iisi getCCTV: ', err)
    return null
  }

  handleLntLng(response)
  return response.data
}

function handleLntLng(response) {
  if (Utils.isEmptyObject(response) || Utils.isEmptyObject(response.data)) {
    return null
  }

  const data = response.data

  for (let i = 0; i < data.length; i++) {
    data[i] = Utils.handleDeviceLntLng(data[i])
    
    if((!Utils.isEmptyObject(data[i].isConnected) && data[i].isConnected !== true) || data[i].isDisabled === true) {
      data[i][CONST.TRAFFIC_CCTV_KEY.TYPE] = CONST.MAP_ICON_TYPE.IISI_DISABLE
    } else {
      data[i][CONST.TRAFFIC_CCTV_KEY.TYPE] = CONST.MAP_ICON_TYPE.IISI
    }
    
  }

  return data
}

export async function postCCTV(cctv = {}) {
  if (Utils.isEmptyObject(cctv) || Utils.isEmptyObject(cctv.id)) {
    console.error('iisi postCCTV: device is null')
    return
  }

  let response = {}
  try {
    response = await axios.post(`${config.eastCoastDataApi()}BaseData/VideoCamera`, cctv)

  } catch (err) {
    console.error('iisi postCCTV: ', err)
    return null
  }

  console.log('post cctv response: ', response)
  Utils.setApiResponsSuccess(response)
  return response
}

export async function putCCTV(cctv = {}) {
  if (Utils.isEmptyObject(cctv) || Utils.isEmptyObject(cctv.id)) {
    console.error('iisi putCCTV: device is null')
    return
  }

  let response = {}
  try {
    response = await axios.put(`${config.eastCoastDataApi()}BaseData/VideoCamera/${cctv.id}`, cctv)

  } catch (err) {
    console.error('iisi putDevice: ', err)
    return null
  }

  console.log('put cctv response: ', response)
  Utils.setApiResponsSuccess(response)
  return response
}

export async function deleteCCTV(cctvId = '') {

}